var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59 39.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#3a3a3a;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.75,12.05h8.74a0,0,0,0,1,0,0V27.78a0,0,0,0,1,0,0H2.75A1.75,1.75,0,0,1,1,26V13.8A1.75,1.75,0,0,1,2.75,12.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.48,27.78,31.62,38.62a1.74,1.74,0,0,0,2.57-1.54V2.75a1.74,1.74,0,0,0-2.57-1.54L11.48,12.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.18,35a23.64,23.64,0,0,0,0-33.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.05,31a18,18,0,0,0,0-25.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.91,27a12.25,12.25,0,0,0,0-17.13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/Sound.31416fa976dbcfb8c98a30fe3b8e6a13.svg";
export { ForwardRef as ReactComponent };